<template>
  <v-container>
    <v-row class="mt-4">
      <v-select label="Idioma" v-model="idioma" :items="idiomes"></v-select>
    </v-row>
    <v-row>
      <v-select
        :label="$t('Operari')"
        v-model="idOperari"
        :items="operaris"
        item-value="id"
        item-text="nom"
        :disabled="desactivat"
      ></v-select>
    </v-row>
    <v-row>
      <v-text-field
        v-model="password"
        :label="$t('Contrasenya')"
        type="password"
      ></v-text-field>
    </v-row>
    <v-row justify="end" class="mt-4">
      <v-btn color="grey" to="/">{{ $t("Cancel·lar") }}</v-btn>
      <v-btn class="ml-3" color="success" @click="guardar">{{
        $t("Acceptar")
      }}</v-btn>
    </v-row>
    <v-alert :value="error" type="error">{{
      $t("Contrasenya_incorrecta")
    }}</v-alert>
  </v-container>
</template>

<script>
import axios from "axios";
import api from "../api.js";
import Cookies from "js-cookie";

export default {
  data: () => ({
    idOperari: Number(Cookies.get("idOperari")),
    operari: {},
    operaris: [],
    password: "",
    error: false,
    desactivat: true,
    idiomes: ["Català", "Castellano"],
    idioma: Cookies.get("idioma"),
  }),
  methods: {
    getOperari() {
      for (var o of this.operaris) {
        if (o.id == this.idOperari) {
          this.operari = o;
          break;
        }
      }
    },
    setIdioma() {
      if (Cookies.get("idioma") == "Català") {
        this.$i18n.locale = "ca";
      } else {
        this.$i18n.locale = "es";
      }
    },
    guardar() {
      this.getOperari();
      if (this.operari.clau == this.password) {
        Cookies.set("idOperari", this.operari.id.toString(), { expires: 8000 });
        Cookies.set("nomOperari", this.operari.nom, { expires: 8000 });
        this.$router.push("/");
      } else {
        this.error = true;
      }
    },
  },
  created() {
    axios.get(api.URL() + "/api/v1/permis").then((response) => {
      if (response.data == "S") {
        this.desactivat = false;
      } else {
        this.desactivat = true;
      }
    });
    axios.get(api.URL() + "/api/v1/operaris").then((response) => {
      this.operaris = response.data;
      this.idOperari = Number(Cookies.get("idOperari"));
    });
    this.setIdioma();
  },
  watch: {
    idioma(val) {
      Cookies.set("idioma", val, { expires: 8000 });
      this.setIdioma();
    },
  },
};
</script>
